var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("custom-light-card", {
        attrs: {
          icon: "mdi-map-marker",
          specificTitleClasses: _vm.isPropertyOrdo ? "success--text" : "",
          subtitle: _vm.item.propertyAdress,
          title: _vm.item.property_shortname
        }
      }),
      _vm._v(" "),
      _c("custom-simple-table", {
        attrs: {
          item: _vm.item,
          "i18-path": "requests.fields",
          specificClasses: _vm.propertyTableStyle,
          "table-keys": _vm.propertyTableKeys
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "font-weight-bold my-2" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.generateMessage("tech_search.property_interventions")) +
            "\n  "
        )
      ]),
      _vm._v(" "),
      _c(
        "loader",
        { attrs: { "is-loading": _vm.isLoadingInProgressItvs } },
        [
          _vm.inProgressPropertyItvs && _vm.inProgressPropertyItvs.length
            ? _c(
                "v-simple-table",
                { staticClass: "background", attrs: { dense: "" } },
                [
                  _c(
                    "tbody",
                    _vm._l(_vm.inProgressPropertyItvs, function(
                      intervention,
                      index
                    ) {
                      return _c("tr", { key: index }, [
                        _c(
                          "td",
                          { staticClass: "caption pa-0 font-weight-bold" },
                          [
                            _c("intervention-date", {
                              attrs: {
                                date: _vm._f("transformDate")(
                                  intervention.event_datetime
                                ),
                                status: _vm._f("getStatus")(intervention)
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("td", { staticClass: "caption px-2" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(intervention.reference) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "caption pa-0 text-end" },
                          [
                            _c(
                              "v-tooltip",
                              {
                                attrs: { bottom: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function({ on }) {
                                        return [
                                          _c("div", _vm._g({}, on), [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  intervention.full_name
                                                    .length > 11
                                                    ? intervention.full_name
                                                        .slice(0, 11)
                                                        .concat("...")
                                                    : intervention.full_name
                                                ) +
                                                "\n                "
                                            )
                                          ])
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              },
                              [
                                _vm._v(" "),
                                _c("div", { staticClass: "text-center" }, [
                                  _c("div", [
                                    _vm._v(_vm._s(intervention.full_name))
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(_vm._s(intervention.phone))
                                  ])
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    }),
                    0
                  )
                ]
              )
            : _c("div", { staticClass: "caption font-italic" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.generateMessage("tech_search.no_data_in_progress")
                    ) +
                    "\n    "
                )
              ]),
          _vm._v(" "),
          _c(
            "loader",
            { attrs: { "is-loading": _vm.isLoadingScheduledItvs } },
            [
              _vm.scheduledPropertyItvs && _vm.scheduledPropertyItvs.length
                ? _c(
                    "v-simple-table",
                    { staticClass: "background", attrs: { dense: "" } },
                    [
                      _c(
                        "tbody",
                        _vm._l(_vm.scheduledPropertyItvs, function(
                          intervention,
                          index
                        ) {
                          return _c("tr", { key: index }, [
                            _c(
                              "td",
                              { staticClass: "caption pa-0 font-weight-bold" },
                              [
                                _c("intervention-date", {
                                  attrs: {
                                    date: _vm._f("transformDate")(
                                      intervention.event_datetime
                                    ),
                                    status: _vm._f("getStatus")(intervention)
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("td", { staticClass: "caption px-2" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(intervention.reference) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "caption pa-0 text-end" },
                              [
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: { bottom: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function({ on }) {
                                            return [
                                              _c("div", _vm._g({}, on), [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      intervention.full_name
                                                        .length > 11
                                                        ? intervention.full_name
                                                            .slice(0, 11)
                                                            .concat("...")
                                                        : intervention.full_name
                                                    ) +
                                                    "\n                  "
                                                )
                                              ])
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  [
                                    _vm._v(" "),
                                    _c("div", { staticClass: "text-center" }, [
                                      _c("div", [
                                        _vm._v(_vm._s(intervention.full_name))
                                      ]),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v(_vm._s(intervention.phone))
                                      ])
                                    ])
                                  ]
                                )
                              ],
                              1
                            )
                          ])
                        }),
                        0
                      )
                    ]
                  )
                : _c("div", { staticClass: "caption font-italic" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.generateMessage("tech_search.no_data_scheduled")
                        ) +
                        "\n      "
                    )
                  ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }